//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BiUserAccessService from '@/apps/data-platform/services/visualization/bi_user_access_service';
import { PATTERNS_VALIDATION } from '@/js/constants';
import tasks from '@/js/tasks';
export default {
  name: 'UserAccessNew',
  props: {
    record: {
      type: Object,
      require: true,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      modalUserAccessNew: 'modalUserAccessNew',
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      dismissCountDown: 0,
      dangerMessage: '',
      dismissSecs: 5,
      validForm: true
    };
  },
  computed: {
    texts: function texts() {
      return {
        user: this.traductor('tablas.user_pbi'),
        name: this.traductor('tablas.name'),
        email: this.traductor('frases.email_inca')
      };
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      var formElement = this.$refs.form;
      console.log(formElement.validate());
      if (!formElement.validate()) return;else {
        var params = {
          record: {
            document_id: this.record.user_id,
            user_dp: this.record.user_dp
          }
        };
        BiUserAccessService.assignUserDP(params).then(function (response) {
          if (response.data.success) {
            tasks.toast.success('Successful request!');
            //this.$toast.success("Successful request!")
            _this.$bvModal.hide(_this.modalUserAccessNew);
            _this.$bus.$emit('onReloadDetail');
          } else {
            //this.dismissCountDown = this.dismissSecs
            //this.dangerMessage = response.data.message
            tasks.toast.error(response.data.message);
            //this.$toast.warning(response.data.message)
          }
        });
      }
    },
    resetModal: function resetModal() {
      this.$bvModal.hide(this.modalUserAccessNew);
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  }
};